import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
export default () => {
  return {
    path: "project-configurations",
    component: withAsyncRouteLoading(
      () =>
        Promise.all([
          import(
            /* webpackChunkName: "configurations" */ "./ProjectConfigurations"
          ),
        ]).then(([importedModule0]) => {
          const component = importedModule0.default;
          return component;
        })
      // .catch(err => {
      //   throw err;
      // })
    ),
  };
};
